export default __webpack_public_path__ + "static/media/kit_image1.76551e91.png";